import * as React from 'react';
export const penfedSvg = React.forwardRef(function penfedSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#2BC3F8',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'm26.32 12.419-.03-.03a1.507 1.507 0 0 0-.45-.37c-.2-.128-.4-.226-.51-.314 0 0 .25.186-.11 1.36l-.12.351-.03.098-.11.323v.02l-.5 1.514-.17.519-.5 1.505-2.14 6.53c-.44 1.281-.99 1.457-.99 1.457.7.167 1.33.01 1.35 0a1.67 1.67 0 0 0 1.09-.958l3.48-10.519c.17-.538.04-1.105-.29-1.515l.03.029Zm-1.76-1.222s-.02-.04-.03-.049a1.427 1.427 0 0 0-.45-.352c-.2-.127-.39-.225-.5-.303 0 0 .25.186-.12 1.398l-.1.303-.03.078c-.08.225-.11.323-.12.352l-.5 1.516-.17.508-.5 1.515-2.61 7.929c-.41 1.144-.9 1.3-.9 1.3.16.04.31.069.44.079h.01c.51.048.86-.069.86-.069.47-.127.88-.47 1.08-.948l2.45-7.342.5-1.506.17-.508.5-1.506.15-.44.15-.44c.17-.537.04-1.095-.29-1.505l.01-.01Zm-1.77-1.281c-.28-.342-.78-.557-.99-.704h.01c.04.069.2.362-.14 1.437-.03.088-.06.186-.1.294-.11.332-.14.43-.14.43l-.5 1.525-.16.499-.5 1.525-3.08 9.326c-.39 1.037-.73 1.193-.73 1.193.09.02.2.03.32.04h.01c.09 0 .18.019.28.019.79.01 1.39-.352 1.65-1.037l2.87-8.603.51-1.515.17-.499.51-1.515.14-.43.15-.46c.17-.537.04-1.104-.3-1.515l.02-.01Z',
      fill: '#FEFEFE',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M21.81 9.222 16.98 5.8a1.716 1.716 0 0 0-1.56-.195s-.64.244-1.12.792c0 0 .57-.176 1.74.645.29.205.37.264.37.264l5.17 3.637.1-.284c.34-1.075.18-1.368.14-1.427l-.01-.01Z',
      fill: '#172C54',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'm21.44 11.363-6.15-4.37a1.75 1.75 0 0 0-1.56-.205s-.59.185-1.08.782c0 0 .5-.166 1.56.557l6.72 4.742.5-1.525.01.02Zm-.67 2.024-7.23-5.152c-.64-.44-1.39-.401-2.06.088-.19.137-.36.293-.48.41 0 0 .38-.068 1.35.567l7.92 5.602.5-1.525v.01Zm-4.15 10.861c-.39 1.037-.73 1.193-.73 1.193H9.38L5.2 12.85l5.33-3.774s.4-.127 1.17.42c.19.138.25.177.25.177l3.73 2.669-3.64 2.571 1.57 4.722h4.53l-1.52 4.614Z',
      fill: '#172C54',
    }),
  );
});
penfedSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var penfed = {
  category: 'brand',
  colorable: false,
  name: 'penfed',
  svg: penfedSvg,
};
